<section class="d-flex justify-content-center">
  <div class="wrapper-div">
    <div class="svg-wrapper">
      <div class="svg-background">
        <svg width="47" height="42" viewBox="0 0 47 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.4336 28.9688H28.4735" stroke="#125896" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14.4414 20.9531H30.4813" stroke="#125896" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M31.8438 9.7016L33.7284 1" stroke="#125896" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M18.4102 9.67709L20.4954 1.01562" stroke="#125896" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M31.082 41.0018H40.6659C43.2523 41.0018 45.2774 38.8163 45.0969 36.2299L43.112 8.92188" stroke="#125896" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M42.9706 10.4422L36.2138 37.5698C35.7326 39.5949 33.9281 40.9983 31.843 40.9983H5.49732C2.46978 40.9983 0.304418 38.0308 1.20666 35.1235L9.64767 8.01624C10.2291 6.13155 11.9735 4.82812 13.9384 4.82812H38.5998C40.5045 4.82812 42.0885 5.99103 42.7501 7.59503C43.1311 8.45717 43.2112 9.43971 42.9706 10.4422Z" stroke="#125896" stroke-width="2" stroke-miterlimit="10"/>
        </svg>
      </div>
    </div>

    <div class="flex-center flex-row mb-40">
      <span class="scegli-data-abb-icon card-body-icons"></span>
      <span style="font-size: 24px;">{{'selling.subscription_ticket.choose_subscription_date' | translate}}</span>
    </div>
    <span class="fz-12 text-center mb-20 text-justify-mobile">{{'selling.subscription_ticket.subscription_ticket_title' | translate}}</span>
    <span class="fz-12 text-center mb-40 text-justify-mobile">{{'selling.subscription_ticket.filter_label' | translate }}</span>
    <div class="search-container">
      <div class="input-wrapper">
        <span class="input-label">{{'selling.barcode' | translate}}</span>
        <input type="text" class="search-input" placeholder="{{'payment_code_label' | translate}}"
          [formControl]="filterSupportId" (keydown.enter)="onSearchSubscriptionTicket()">
      </div>
      <div class="btns">
        <button class="reset-btn" (click)="onSearchSubscriptionTicket()">
          {{'general.reset' | translate}}
        </button>
        <button class="btn-orange orange-shadow btn-apply-loading" (click)="onSearchSubscriptionTicket()" [disabled]="showLoading">
          <span [style.visibility]="showLoading ? 'hidden' : 'visible'" style="color: inherit">{{'general.search' | translate}}</span>
          @if (showLoading) {
            <div class="loader-inline"></div>
          }
        </button>
      </div>
    </div>
      @if (subscriptionCartItems?.length) {
        @for (subscriptionCartItem of subscriptionCartItems; track trackBySubscription(subIdx, subscriptionCartItem); let subIdx = $index) {
          <div>
            <app-subscription-ticket-item
              [supportId]="supportId"
              [subscriptionCartItem]="subscriptionCartItem"
              [isExpanded]="expSubIdx === subIdx"
              [multipleCartItem]="subscriptionCartItems.length > 1"
              (toggleExpansionOserver)="onSetExpandedItemIdx(subIdx)"
              (refreshSubscriptionticketsOserver)="onSearchSubscriptionTicket(true)"
              [subscriptionType]="subscriptionType">
            </app-subscription-ticket-item>
          </div>
        }
      } @else {
        <div class="d-flex flex-column align-items-center justify-content-center" style="height: 200px;">
          @if (subscriptionCartItems?.length === 0) {
            <div class="empty-cart-cls text-center pt-30 pb-30">
                <div class="empty-cart-icon"></div>
                <h4 class="not-found-text">{{'selling.subscription_ticket.title_no_found' | translate}}</h4>
            </div>
          }
          @if (searchCartItemsError === true) {
            <span class="material-symbols-outlined fz-48 text-center" style="color: #f44336">error_outline</span>
            <h3 class="w100 text-center t-bold">{{ 'errors.search_error' | translate }}</h3>
          }
        </div>
      }
  </div>
</section>